module.exports = __webpack_public_path__ + "img/wolf-min.e395c599.png";